import React, { useCallback, useContext } from 'react';
import { UserContext } from 'venn-components';
import moment from 'moment';
import { cn } from '@/lib/utils';
import { Icon, NewBadge } from 'venn-ui-kit';
import { DISMISSED_BLOCK_ASSIGNMENT_TUTORIAL_KEY } from 'venn-api';
import { PanelItem } from '../../../studio-right-panel/tabs/sections/components/shared';

const getIsNewUser = (created: number | undefined) => {
  return moment.utc(created).isSameOrAfter(moment.utc('2025-10-29'));
};

export const DismissableInputTutorial = () => {
  const { profileSettings, settings, updateSettings } = useContext(UserContext);
  const isNewUser = getIsNewUser(profileSettings?.user.created);
  const hasDismissed = settings.user[DISMISSED_BLOCK_ASSIGNMENT_TUTORIAL_KEY];

  const onDismiss = useCallback(() => {
    updateSettings({
      [DISMISSED_BLOCK_ASSIGNMENT_TUTORIAL_KEY]: true,
    });
  }, [updateSettings]);

  if (hasDismissed) {
    return null;
  }

  return (
    <PanelItem>
      <div
        className={cn('px-[10px] py-[12px] text-[12px]', {
          'bg-venn-switch-light': isNewUser,
          'bg-venn-highlight-pale': !isNewUser,
        })}
      >
        <div className={cn('flex mb-[4px]')}>
          <div className={cn('flex items-end gap-[4px] flex-1 font-bold')}>
            {!isNewUser && <NewBadge refreshedStyling />} How to set block inputs
          </div>
          <button type="button" onClick={onDismiss} className={cn('text-venn-dark-blue')}>
            <Icon type="close" />
          </button>
        </div>
        Subjects, date ranges, and benchmarks for this block are managed here in the Inputs panel.
      </div>
    </PanelItem>
  );
};
